import { feApi } from "@/app/api/utils/api";
import { ApiResponse, MetaProps } from "@/types";
import { FilterProps, NewsBeResponse } from "./news.server";

export async function getNewsClient(props: FilterProps) {
  const searchParams = new URLSearchParams({
    page: props.page?.toString() ?? "1",
    pageSize: props.pageSize?.toString() ?? "4",
    year: props?.year?.toString() ?? "",
    category: props?.category?.toString() ?? "",
    locale: props.locale,
    order: "asc",
  });

  searchParams.forEach((value, key) => {
    if (!value.length) {
      searchParams.delete(key);
    }
  });

  if (!props.category) {
    searchParams.delete("category");
  }

  try {
    const res = (await feApi.get(
      `/v1/${props.locale}/news?` + searchParams.toString()
    )) as ApiResponse<NewsBeResponse>;

    const d = res?.data.data;

    return {
      data: d,
      meta: res?.data?.meta as unknown as MetaProps["pagination"],
    };
  } catch (error) {
    console.log("getNews", error);

    return null;
  }
}
